import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LogoIcon from '../Assets/Images/BigLogoIcon.png';
import DarkLogoIcon from '../Assets/Images/BigDarkLogoIcon.png';
import { NorthEast } from '@mui/icons-material';
import { useAppContext } from '../context/useAppContext';
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from 'react-router-dom';

function LetsTalk() {
    const { darkTheme } = useAppContext();
    const navigate = useNavigate()

    const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
    const [hover, setHover] = useState(false);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const handleMouseMove = (e) => {
        setCursorPos({
            x: e.clientX,
            y: e.clientY,
        });
    };

    return (
        <Box
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onMouseMove={handleMouseMove}
            onClick={()=>{navigate('/contact')}}
            sx={{
                cursor: hover ? "none" : "default",
                position: "relative",
                "& *": {
                    cursor: hover ? "none !important" : "default",
                },
            }}
        >
            {/* Heading */}
            <Typography
                data-aos="fade-up"
                gutterBottom
                className='text-color-main fs-42'
                fontWeight={550}
            >
                Any Ideas?
            </Typography>

            {/* Main Section */}
            <Box
                position={'relative'}
                className='d-flex align-items-center'
                gap={{xs:"20px",md:'50px'}}
            >
                <Typography
                    data-aos="fade-up"
                    className='text-color-main'
                    sx={{
                        whiteSpace:'nowrap',
                        fontSize: {
                            xs: "50px",
                            sm: "100px",
                            md: "150px",
                            lg: "175px",
                            xl: "285px",
                        }
                    }}
                    fontWeight={550}
                >
                    LET'S TALK
                </Typography>

                <Box
                    component={'img'}
                    height={{xs:"50px",sm:"100px",md:'150px', lg:"200px"}}
                    src={darkTheme ? DarkLogoIcon : LogoIcon}
                />
            </Box>

            {/* Custom Cursor */}
            {hover && (
                <Box
                    className='contact d-flex align-items-center flex-column justify-content-center'
                    sx={{
                        position: "fixed",
                        top: cursorPos.y,
                        left: cursorPos.x,
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "none",
                        zIndex: 9999,
                        transition: "transform 0.05s linear",
                        // background: darkTheme ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.7)",
                        backdropFilter: "blur(10px)",
                        borderRadius: "50%",
                        padding: "20px",
                        color: "#fff",
                    }}
                >
                    <Box sx={{ fontSize: "30px", mb: 1 }}>
                        <NorthEast sx={{ fontSize: '34px' }} />
                    </Box>
                    <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                        Contact Us
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default LetsTalk;